
















import Vue, { PropType } from "vue";
import { defineComponent } from "@vue/composition-api";
import { FormFields, FormValues } from "@/types";
import BaseFlexForm from "@/components/BaseFlexForm.vue";

Vue.component("BaseFlexForm", BaseFlexForm);

export default defineComponent({
  name: "BaseFilter",
  props: {
    fields: { type: Array as () => PropType<FormFields>, required: true },
    flexClass: { type: String },
    values: { type: Object as () => PropType<FormValues>, required: true },
  },
  model: {
    event: "input",
    prop: "values",
  },
});
